import { render, staticRenderFns } from "./PodcastPaywall.vue?vue&type=template&id=2916ed70&scoped=true"
import script from "./PodcastPaywall.vue?vue&type=script&lang=ts"
export * from "./PodcastPaywall.vue?vue&type=script&lang=ts"
import style0 from "./PodcastPaywall.vue?vue&type=style&index=0&id=2916ed70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916ed70",
  null
  
)

export default component.exports